import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-share': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.6 8C389.4 8 496 118.1 496 256 496 403.1 377.5 504 247.6 504 113.6 504 0 394.5 0 256 0 123.1 104.7 8 247.6 8zM248.4 52.7C130.2 52.7 44.7 150.6 44.7 256 44.7 365.8 135.9 458.8 248.4 458.8 351.6 458.8 451.2 377.7 451.2 256 451.3 142.2 361 52.7 248.4 52.7zM349.4 185.1C357.2 185.1 363.1 191.2 363.1 198.8V381.3C363.1 389 357 395 349.4 395H214.3C206.6 395 200.6 389 200.6 381.3V327.3H146.6C138.8 327.3 132.9 321.3 132.9 313.6V131.1C132.9 122.9 139.5 118.4 145.3 117.4H281.7C289.4 117.4 295.4 123.4 295.4 131.1V185.1H349.4zM159.9 300.3H200.6V198.9C200.6 191.5 206.4 186.3 212.6 185.2H268.4V144.9H159.9V300.3zM336.1 212.2H227.6V367.6H336.1V212.2z'
      }
    ]
  }
})
